var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length > 0)?_c('div',{staticClass:"top-rolling"},[_c('Rolling',{ref:"rolling"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index + 'rolling'},[_vm._v("\n      "+_vm._s(item.content)+"\n    ")])}),0)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }